import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { getContactName } from 'helpers/_helpers';
import { useMemo, useState } from 'react';
import classnames from 'classnames';
import ContactCreator from 'components/WorklogDetails/components/GeneralInfoBlock/components/GeneralInfoForm/components/ContactCreator/ContactCreator';
import { SearchSelect } from 'lib';

export const AlternateContacts = ({
  CloseIcon,
  classes,
  values,
  setFieldValue,
  contractorAlternateContacts,
  setContractorAlternateContacts,
}) => {
  const [contactCreateForm, setContactCreateForm] = useState(false);

  const contactOptions = useMemo(() => (
    contractorAlternateContacts.filter((contact) => (
      !values.alternateContacts.find((cont) => contact._id === cont)
    )).sort((a, b) => a.name.localeCompare(b.name))
  ), [contractorAlternateContacts, values.alternateContacts])

  const handleSelectContact = (i) => (contactId) => {
    const id = contactId ?? '';


    const nextValue = values.alternateContacts.map((t, index) => (index === i ? id : t));
    setFieldValue('alternateContacts', nextValue);
  };

  const handleContactCreateForm = (value) => {
    if (value === false) {
      setContactCreateForm(value);
      return;
    }
    setContactCreateForm(value.toString());
  };
  const handleEmailRemoving = (i) => () => {
    const nextValue = values.alternateContacts.filter((_, index) => index !== i);
    setFieldValue('alternateContacts', nextValue.length ? nextValue : ['']);
  };

  const handleAddContact = () => {
    if (contractorAlternateContacts.length > values.alternateContacts.length) {
      setFieldValue('alternateContacts', [...values.alternateContacts, '']);
    }
  };

  return (
    <>
      {!!values.alternateContacts?.length &&
        values.alternateContacts.map((contactId, index) => (
          <Grid item xs={12} className={classes.zeroPaddingTop} key={contactId + '_ ' + index}>
            <label htmlFor="alternateContacts">
              <Typography variant="body1" color="textSecondary">
                {index === 0 ? 'Primary Contact' : `Alternate Contact ${index}`}:
              </Typography>
              <div className={classes.flexBox}>
                <div className={classes.flexGrow}>
                  <SearchSelect
                    value={contactId}
                    onChange={handleSelectContact(index)}
                    options={[
                      contractorAlternateContacts.find((c) => c._id === contactId),
                      ...contactOptions,
                    ].filter(Boolean)}
                    getOptionLabel={(option) => getContactName(option)}
                    inputProps={{ id: `alternateContacts[${index}]`, 'aria-label': 'Contact' }}
                    footer={
                      <Button
                        variant="text"
                        className={classes.primaryTextButton}
                        onClick={() => handleContactCreateForm(index)}
                        disableRipple
                      >
                        + Create New Contact
                      </Button>
                    }
                  />
                </div>
                <IconButton
                  className={classes.deleteLocationButton}
                  onClick={handleEmailRemoving(index)}
                  aria-label="Delete"
                  disableTouchRipple
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </label>
          </Grid>
        ))}
      {values.contractorId &&
        !!contractorAlternateContacts?.length &&
        contractorAlternateContacts?.length > values.alternateContacts?.length && (
          <Grid item xs={12} className={classes.zeroPaddingTop}>
            <div className={classes.primaryAdd} onClick={handleAddContact}>
              <span>+ Add Alternate Contact</span>
            </div>
          </Grid>
        )}
      <Grid item xs={12} className={classes.zeroPadding}>
        {contactCreateForm ? (
          <ContactCreator
            values={values}
            setCurrContractorContacts={setContractorAlternateContacts}
            setValue={setFieldValue}
            setContactCreatorForm={setContactCreateForm}
            contactIndex={contactCreateForm}
          />
        ) : null}
      </Grid>
    </>
  );
};
